export default "__VITE_ASSET__30edaf46__"